import * as i from "react";
import "react-dom";
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function b() {
  return b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b.apply(this, arguments);
}
var L;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(L || (L = {}));
function d(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function E(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: r = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), r && r !== "#" && (t += r.charAt(0) === "#" ? r : "#" + r), t;
}
function W(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substr(r), e = e.substr(0, r)), e && (t.pathname = e);
  }
  return t;
}
var N;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(N || (N = {}));
function X(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function Q(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: r = "",
    hash: a = ""
  } = typeof e == "string" ? W(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : Y(n, t) : t,
    search: D(r),
    hash: H(a)
  };
}
function Y(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((a) => {
    a === ".." ? n.length > 1 && n.pop() : a !== "." && n.push(a);
  }), n.length > 1 ? n.join("/") : "/";
}
function x(e, t, n, r) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(r) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function Z(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function M(e, t) {
  let n = Z(e);
  return t ? n.map((r, a) => a === n.length - 1 ? r.pathname : r.pathnameBase) : n.map((r) => r.pathnameBase);
}
function T(e, t, n, r) {
  r === void 0 && (r = !1);
  let a;
  typeof e == "string" ? a = W(e) : (a = b({}, e), d(!a.pathname || !a.pathname.includes("?"), x("?", "pathname", "search", a)), d(!a.pathname || !a.pathname.includes("#"), x("#", "pathname", "hash", a)), d(!a.search || !a.search.includes("#"), x("#", "search", "hash", a)));
  let s = e === "" || a.pathname === "", l = s ? "/" : a.pathname, u;
  if (l == null)
    u = n;
  else {
    let h = t.length - 1;
    if (!r && l.startsWith("..")) {
      let p = l.split("/");
      for (; p[0] === ".."; )
        p.shift(), h -= 1;
      a.pathname = p.join("/");
    }
    u = h >= 0 ? t[h] : "/";
  }
  let c = Q(a, u), o = l && l !== "/" && l.endsWith("/"), f = (s || l === ".") && n.endsWith("/");
  return !c.pathname.endsWith("/") && (o || f) && (c.pathname += "/"), c;
}
const _ = (e) => e.join("/").replace(/\/\/+/g, "/"), D = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, H = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, B = ["post", "put", "patch", "delete"];
new Set(B);
const ee = ["get", ...B];
new Set(ee);
/**
 * React Router v6.28.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function w() {
  return w = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w.apply(this, arguments);
}
const F = /* @__PURE__ */ i.createContext(null), m = /* @__PURE__ */ i.createContext(null), A = /* @__PURE__ */ i.createContext(null), C = /* @__PURE__ */ i.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
function te(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  R() || d(!1);
  let {
    basename: r,
    navigator: a
  } = i.useContext(m), {
    hash: s,
    pathname: l,
    search: u
  } = K(e, {
    relative: n
  }), c = l;
  return r !== "/" && (c = l === "/" ? r : _([r, l])), a.createHref({
    pathname: c,
    search: u,
    hash: s
  });
}
function R() {
  return i.useContext(A) != null;
}
function y() {
  return R() || d(!1), i.useContext(A).location;
}
function J(e) {
  i.useContext(m).static || i.useLayoutEffect(e);
}
function ne() {
  let {
    isDataRoute: e
  } = i.useContext(C);
  return e ? le() : re();
}
function re() {
  R() || d(!1);
  let e = i.useContext(F), {
    basename: t,
    future: n,
    navigator: r
  } = i.useContext(m), {
    matches: a
  } = i.useContext(C), {
    pathname: s
  } = y(), l = JSON.stringify(M(a, n.v7_relativeSplatPath)), u = i.useRef(!1);
  return J(() => {
    u.current = !0;
  }), i.useCallback(function(o, f) {
    if (f === void 0 && (f = {}), !u.current) return;
    if (typeof o == "number") {
      r.go(o);
      return;
    }
    let h = T(o, JSON.parse(l), s, f.relative === "path");
    e == null && t !== "/" && (h.pathname = h.pathname === "/" ? t : _([t, h.pathname])), (f.replace ? r.replace : r.push)(h, f.state, f);
  }, [t, r, l, s, e]);
}
function K(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    future: r
  } = i.useContext(m), {
    matches: a
  } = i.useContext(C), {
    pathname: s
  } = y(), l = JSON.stringify(M(a, r.v7_relativeSplatPath));
  return i.useMemo(() => T(e, JSON.parse(l), s, n === "path"), [e, l, s, n]);
}
var $ = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}($ || {}), z = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(z || {});
function ae(e) {
  let t = i.useContext(F);
  return t || d(!1), t;
}
function ie(e) {
  let t = i.useContext(C);
  return t || d(!1), t;
}
function se(e) {
  let t = ie(), n = t.matches[t.matches.length - 1];
  return n.route.id || d(!1), n.route.id;
}
function le() {
  let {
    router: e
  } = ae($.UseNavigateStable), t = se(z.UseNavigateStable), n = i.useRef(!1);
  return J(() => {
    n.current = !0;
  }), i.useCallback(function(a, s) {
    s === void 0 && (s = {}), n.current && (typeof a == "number" ? e.navigate(a) : e.navigate(a, w({
      fromRouteId: t
    }, s)));
  }, [e, t]);
}
new Promise(() => {
});
/**
 * React Router DOM v6.28.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function U() {
  return U = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U.apply(this, arguments);
}
function oe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function ue(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function ce(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !ue(e);
}
const fe = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"], he = "6";
try {
  window.__reactRouterVersion = he;
} catch {
}
const de = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", pe = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, ge = /* @__PURE__ */ i.forwardRef(function(t, n) {
  let {
    onClick: r,
    relative: a,
    reloadDocument: s,
    replace: l,
    state: u,
    target: c,
    to: o,
    preventScrollReset: f,
    viewTransition: h
  } = t, p = oe(t, fe), {
    basename: V
  } = i.useContext(m), P, S = !1;
  if (typeof o == "string" && pe.test(o) && (P = o, de))
    try {
      let v = new URL(window.location.href), g = o.startsWith("//") ? new URL(v.protocol + o) : new URL(o), O = X(g.pathname, V);
      g.origin === v.origin && O != null ? o = O + g.search + g.hash : S = !0;
    } catch {
    }
  let k = te(o, {
    relative: a
  }), q = ve(o, {
    replace: l,
    state: u,
    target: c,
    preventScrollReset: f,
    relative: a,
    viewTransition: h
  });
  function G(v) {
    r && r(v), v.defaultPrevented || q(v);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ i.createElement("a", U({}, p, {
      href: P || k,
      onClick: S || s ? r : G,
      ref: n,
      target: c
    }))
  );
});
var j;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(j || (j = {}));
var I;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(I || (I = {}));
function ve(e, t) {
  let {
    target: n,
    replace: r,
    state: a,
    preventScrollReset: s,
    relative: l,
    viewTransition: u
  } = t === void 0 ? {} : t, c = ne(), o = y(), f = K(e, {
    relative: l
  });
  return i.useCallback((h) => {
    if (ce(h, n)) {
      h.preventDefault();
      let p = r !== void 0 ? r : E(o) === E(f);
      c(e, {
        replace: p,
        state: a,
        preventScrollReset: s,
        relative: l,
        viewTransition: u
      });
    }
  }, [o, c, f, r, a, n, e, s, l, u]);
}
export {
  ge as L
};
